import Const from 'constants';
import Action from 'actions';

const LegacyControlledHittersStackingAction = {
    useHitterStack(use) {
        return {
            type: Const.USE_HITTERS_STACK,
            use,
        };
    },

    setHittersDoubleStackMode(data) {
        return (dispatch) => {
            dispatch({
                type: Const.HITTERS_STACK_IS_DOUBLE_STACK_MODE,
                data,
            });

            dispatch(this.saveLegacyControlledHitterStackingToStorage());
        };
    },

    setHitterStackPayersInGroup(groupNumber, value) {
        return (dispatch) => {
            dispatch({
                type: Const.SET_HITTER_STACK_PLAYERS_IN_GROUP,
                groupNumber,
                value,
            });

            dispatch(this.saveLegacyControlledHitterStackingToStorage());
        };
    },

    addHittersStackItem(groupNumber) {
        return (dispatch) => {
            dispatch({
                type: Const.HITTERS_STACK_ADD_ITEM,
                groupNumber,
            });

            dispatch(this.saveLegacyControlledHitterStackingToStorage());
        };
    },

    removeHittersStackItem(groupNumber, itemNumber) {
        return (dispatch) => {
            dispatch({
                type: Const.HITTERS_STACK_REMOVE_ITEM,
                groupNumber,
                itemNumber,
            });

            dispatch(this.saveLegacyControlledHitterStackingToStorage());
        };
    },

    setHittersStackTeam(groupNumber, itemNumber, team) {
        return (dispatch) => {
            dispatch({
                type: Const.HITTERS_STACK_SET_TEAM_TO_ITEM,
                groupNumber,
                itemNumber,
                team,
            });

            dispatch(this.saveLegacyControlledHitterStackingToStorage());
        };
    },
    setHittersStackExposure(groupNumber, itemNumber, exposure) {
        return (dispatch) => {
            dispatch({
                type: Const.HITTERS_STACK_SET_EXPOSURE_TO_ITEM,
                groupNumber,
                itemNumber,
                exposure,
            });

            dispatch(this.saveLegacyControlledHitterStackingToStorage());
        };
    },

    setHittersStackPlayers(groupNumber, itemNumber, playerIds) {
        return (dispatch) => {
            dispatch({
                type: Const.HITTERS_STACK_SET_PLAYER_TO_ITEM,
                groupNumber,
                itemNumber,
                playerIds,
            });

            dispatch(this.saveLegacyControlledHitterStackingToStorage());
        };
    },

    setLegacyControlledHittersStackingSettingsFromStorage(data) {
        return (dispatch) => {
            dispatch({
                type: Const.HITTERS_STACK_SET_DATA_FROM_STORAGE,
                data,
            });
        };
    },

    saveLegacyControlledHitterStackingToStorage() {
        return (dispatch) => {
            dispatch(
                Action.saveDataToStorage('legacyControlledHitterStacking', function (state) {
                    const {
                        stacks: {hitters},
                    } = state;

                    return {...hitters.data};
                }),
            );
        };
    },
};

export default LegacyControlledHittersStackingAction;
